import { RouterRootState } from "connected-react-router";
import React, { FC, ReactNode, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import AccessProfileModal from "../../../components/access-profile/add/AccessProfileModal";
import ActivityFrame from "../../../components/activity-frame/activity-frame";
import Breadcrumb from "../../../components/breadcrumb/breadcrumb";
import Tabs, { getTabsListFromLabels } from "../../../components/tabs/tabs";
import { toast } from "react-toastify";
import AccessProfilesTab from "../../../containers/access-profiles-tab";
import { useLocale } from "../../../contexts/localeContext";
import Restricted from "../../../contexts/PermissionProvider/RestrictedWrapper";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import plusIcon from "../../../images/Plus.svg";
import { Category } from "../../../models/Category";
import { showError } from "../../../services/utilities/ServiceError";
import { shouldUpdateCategory } from "../../../utilities/tabUtils";
import { useTabCount } from "../../../hooks/useCategoryTab";

const getRouteNameFromPath = (path: string) => {
    const splitPath = path.split('/');
    return splitPath[splitPath.length - 1];
}

const AccessProfiles: FC = () => {
    const [busy, setBusy] = useState(false);
    const history = useHistory();
    const [categories, setCategories] = useState<Category[]>([]);
    const [selected, setSelected] = useState(0);
    const [tabContent, setTabContent] = useState<ReactNode[]>([]);
    const [showAccessProfileWizard, setShowAccessProfileWizard] = useState<boolean>(false)
    const { translate } = useLocale();
    const routeName = useSelector((state: RouterRootState) => getRouteNameFromPath(state.router.location.pathname));

    const { updateTabCount } = useTabCount({
        tableName: "AccessProfile",
        categories,
        setCategories,
    });

    useEffect(() => {
        buildCategoriesData();
    }, []);

    const buildCategoriesData = async () => {
        try {
            setBusy(true);
            setCategories([
                {
                    displayName: translate.byKey(TranslationKeys.accessProfiles),
                    heading: translate.byKey(TranslationKeys.accessProfiles),
                    value: "",
                    id: 0,
                    count: 0 
                }
            ]);
            setBusy(false);

        } catch (error) {
            showError(error, toast.warn);
        }
    }

    useEffect(() => {
        if (categories.length > 0) {
            const newTabContent = [
                <AccessProfilesTab
                    setBusy={setBusy}
                    onFilterChange={onFilterChange}
                    setShowAccessProfileWizard={setShowAccessProfileWizard}
                    categories={categories}
                    setCategories={setCategories} />
            ];
            setTabContent(newTabContent);
        }
    }, [categories]);

    const onFilterChange = () => {
        updateTabCount([]);
    }

    return <ActivityFrame
        busy={busy}
        className="flex flex-grow overflow-y-hidden">
        <div className="pt-4 pl-4 pb-4 flex flex-col flex-grow">
            <Breadcrumb
                path={[
                    {
                        value: "/access-control/enrolment",
                        displayName: translate.byKey(TranslationKeys.enrolments),
                    },
                    {
                        value:
                            "/access-control/enrolment/access-profiles",
                        displayName: translate.byKey(TranslationKeys.accessProfiles),
                    },
                ]}
                onClick={(item) => history.push(item.value)} />
            <Tabs
                className="overflow-y-hidden"
                tabs={getTabsListFromLabels(categories)}
                onSelect={(i) => setSelected(i)}
                selected={selected}
                onAdd={() => { }}
                add={false}
                tabStyle={{}}>
                {tabContent[selected]}
                <div className="flex flex-col flex-grow overflow-y-hidden mb-viewport">
                    <div className="flex flex-row justify-end button-cluster">
                        <Restricted to={`add.${routeName}.element`}>
                            <button onClick={() => setShowAccessProfileWizard(true)} className="flex rounded-lg bg-lime text-white p-2 shadow-lg" id="addBtn">
                                <img
                                    src={plusIcon}
                                    className="px-2 w-8 py-1"
                                    alt="" />
                                <span className="mr-2">{translate.byKey(TranslationKeys.add)}</span>
                            </button>
                        </Restricted>
                    </div>
                </div>
            </Tabs>
            <AccessProfileModal isOpen={showAccessProfileWizard} onClose={() => setShowAccessProfileWizard(false)} setBusy={setBusy} />
        </div>
    </ActivityFrame>
};

export default AccessProfiles;
